//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  props: ['resources', 'direction', 'grid_type', 'content_type', 'slug', 'ratio', 'item_list_id', 'item_list_name', 'thumb_type']
};
